import { create } from "zustand";
import { getCategories } from "../../services/Products/ProductServices";

export const useCategoryStore = create((set, get) => ({
  categories: [],
  categoryJewelry: [],
  categoryGifts: [],
  gifts: ["gifts-under-25usd", "gifts-for-her", "gifts-for-him"],
  isLoadding: false,
  filterJewelry: (items) => {
    const gifts = get().gifts;
    let data = items.filter((item) => !gifts.includes(item.slug));

    return data;
  },

  filterGifts: (items) => {
    const gifts = get().gifts;
    let data = items.filter((item) => gifts.includes(item.slug));
    return data;
  },

  getCategoriesApi: async () => {
    set({ isLoadding: true });
    let data = await getCategories(); // gọi API từ bên ngoài

    if (data && data.length > 0) {
      const filterJewelry = get().filterJewelry;
      const filterGifts = get().filterGifts;

      set({
        categories: data,
        categoryJewelry: filterJewelry(data),
        categoryGifts: filterGifts(data),
      });
    }
    set({ isLoadding: false });
  },
}));
